import React from 'react';
import { di } from 'react-magnetic-di';
import { LazySuspense, lazyForPaint } from 'react-loosely-lazy';
import { Skeleton } from '@pole-journal-web/app-screen-skeleton';

const AsyncContact = lazyForPaint(
    () => import(/* webpackChunkName: "async-contact" */ './index')
        .then(({ Contact }) => Contact)
);

export const Contact = () => {
    di(AsyncContact, LazySuspense, Skeleton);

    return (
        <LazySuspense fallback={<Skeleton />}>
            <AsyncContact />
        </LazySuspense>
    );
};
